import React, { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import PageLayout from "examples/LayoutContainers/PageLayout";
import impresLogo from "../../../assets/ImpLogo.jpg";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

const AdminRegister = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRegister = (e) => {
    e.preventDefault();
    setLoading(true);
    // TODO: Implement registration logic here
    setTimeout(() => setLoading(false), 1200);
  };

  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto" display="flex" alignItems="center" justifyContent="center">
        <Card sx={{ maxWidth: 400, width: "100%", p: { xs: 2, sm: 4 }, borderRadius: 4, boxShadow: 8, zIndex: 2 }}>
          <MDBox display="flex" flexDirection="column" alignItems="center" mb={2}>
            <MDBox component="img" src={impresLogo} alt="Impres Logo" width={70} mb={1} />
            <MDTypography variant="h4" fontWeight="bold" color="info" textAlign="center" mb={1}>
              Admin Register
            </MDTypography>
            <MDTypography variant="body2" color="text" textAlign="center" mb={2}>
              Create your admin account to get started.
            </MDTypography>
          </MDBox>
          <form onSubmit={handleRegister}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Name"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="name"
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
              />
            </MDBox>
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              fullWidth
              disabled={loading}
              sx={{ fontWeight: 600, fontSize: 16, borderRadius: 2 }}
            >
              {loading ? "Registering..." : "Register"}
            </MDButton>
            <MDBox mt={3} mb={1} textAlign="center" display="flex" flexDirection="column" alignItems="center">
              <MDTypography variant="button" color="text" display="flex" alignItems="center">
                Already have an account?
                <span style={{ marginLeft: 6, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                  onClick={() => window.location.href = "/AdminLogin"}>
                  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" style={{ marginRight: 4, color: '#1A73E8' }}><path d="M0 0h24v24H0z" fill="none"/><path fill="#1A73E8" d="M10.09 15.59L8.67 17l-5-5 5-5 1.41 1.41L6.83 11H20v2H6.83l3.26 3.59z"/></svg>
                  <span style={{ color: '#1A73E8', fontWeight: 600 }}>Sign in</span>
                </span>
              </MDTypography>
            </MDBox>
          </form>
        </Card>
      </MDBox>
    </PageLayout>
  );
};

export default AdminRegister;
